import { createReducer, on } from '@ngrx/store';
import * as CategoriesActions from './../actions/categories.actions';
import { AdCategories } from '../../models/ad-categories.model';

export interface CategoriesState {
  categories: AdCategories | null;
  loading: boolean;
  error: any;
}

export const initialState: CategoriesState = {
  categories: null,
  loading: false,
  error: null,
};

export const categoriesReducer = createReducer(
  initialState,

  on(CategoriesActions.loadCategories, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CategoriesActions.loadCategoriesSuccess, (state, { categories }) => ({
    ...state,
    loading: false,
    categories,
  })),

  on(CategoriesActions.loadCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CategoriesActions.alreadyLoaded, (state) => ({
    ...state,
    loading: false,
  }))
);
